import Api from "api";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setDialog, setLoading } from "slices/appSlice";
import { formErrorStrfromObj } from "utils/shared";

export function useCreateReleaseSchedule() {
  const dispatch = useDispatch();
  const createReleaseSchedule = useCallback(
    async (releaseSchedule, cb = () => {}) => {
      let response;
      try {
        dispatch(setLoading(true));
        response =
          await Api.ReleaseSchedule.createReleaseSchedule(releaseSchedule);
        if (response.status === 201) {
          cb();
          dispatch(
            setDialog({
              message: "Release schedule created successfully",
              title: "Success",
            })
          );
        } else if (response.data.length < 1) {
          dispatch(
            setDialog({
              message: "API returned an empty list of health plans",
              title: "Error",
            })
          );
        }
      } catch (e) {
        dispatch(
          setDialog({ message: formErrorStrfromObj(e), title: "Error" })
        );
      } finally {
        dispatch(setLoading(false));
      }
      return response;
    },
    [dispatch]
  );

  return [createReleaseSchedule];
}
